import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { ApiService } from './api.service'
import { FileUploader } from 'ng2-file-upload';
import { UserModel, CorpInfo } from './index';
import { Observable } from 'rxjs/Observable';
import { BASE_URL } from '../utils/index';
declare var moment:any;

@Injectable()
export class BannerService {

  constructor(private http: Http, private apiService:ApiService) {};

  getBannerList(){
		return this.apiService.get('banner');
	}
}

export class BannerModel{
  bannerId:number;
  bannerSpecialityList:Array<BannerSpecialityModel>;
  bannerStatusCd:number;
  bannerStatusNm:string;
  bannerTypeCd:number;
  bannerTypeNm:string;
  cntryCd:string;
  cntryNm:string;
  content:string;
  corpId:number;
  corpNm:string;
  delYn:number;
  corporation:CorpInfo;
  title:string;
  insUser:UserModel;
  updUser:UserModel;
  isActivity: number;
  startDt:string;
  endDt:string;
  contractStatusNm:string;
}

export class BannerSpecialityModel {
  itemId:number;
  itemTpCd:number;
  itemTpNm: string;
  itemNm: string;
  remark: string;
  itemNmKr: string;
}


// WEBPACK FOOTER //
// ./src/app/services/banner.service.ts